import { render, staticRenderFns } from "./ProductStock.vue?vue&type=template&id=7ea29355"
import script from "./ProductStock.vue?vue&type=script&lang=js"
export * from "./ProductStock.vue?vue&type=script&lang=js"
import style0 from "./ProductStock.vue?vue&type=style&index=0&id=7ea29355&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports